import { Auth } from "aws-amplify";
import { TOKEN } from "shared/constants/LocalStorageConsts";
import { getBrowserId, loadUserId } from "./browser-id";

export const autenticado = () => {
  return localStorage.getItem(TOKEN) != null;
};

export const hasClaim = (claim: string, loggedUser: any) => {
  return loggedUser?.claims
    ?.map((cl: string) => cl.toUpperCase())
    .some((item: any) => item.includes(claim?.toUpperCase()));
};

export const logout = async (keepSession: boolean = true) => {
  const ignoredPaths = ["/login", "/signup", "/radar"];
  try {
    await Auth.signOut({ global: true });
  } finally {
    if (keepSession && !ignoredPaths.includes(window.location.pathname)) {
      sessionStorage.setItem("returnURL", window.location.pathname);
    }
    const browserId = getBrowserId();
    localStorage.clear();
    loadUserId(browserId);
    window.location.href = "/login";
  }
};
